"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    width: "25",
    height: "25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M12.5,25C5.6,25,0,19.4,0,12.5S5.6,0,12.5,0S25,5.6,25,12.5S19.4,25,12.5,25z M12.5,1C6.2,1,1,6.2,1,12.5S6.2,24,12.5,24 S24,18.8,24,12.5S18.8,1,12.5,1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M10.4,14.9c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8S10.8,14.9,10.4,14.9z M10.4,13.9 c-0.1,0-0.2,0.1-0.2,0.2c0,0.3,0.5,0.3,0.5,0C10.6,14,10.5,13.9,10.4,13.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M10.4,16.5c-0.3,0-0.5-0.2-0.5-0.5v-1.6c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5V16 C10.9,16.3,10.6,16.5,10.4,16.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M14.9,19.2H5.8c-0.3,0-0.5-0.2-0.5-0.5v-7.5c0-0.3,0.2-0.5,0.5-0.5h9.1c0.3,0,0.5,0.2,0.5,0.5v7.5 C15.4,18.9,15.2,19.2,14.9,19.2z M6.3,18.2h8.1v-6.5H6.3V18.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M13.8,11.2h-1V9.3c0-1.9,1.5-3.4,3.4-3.4c1.9,0,3.4,1.5,3.4,3.4h-1c0-1.3-1.1-2.4-2.4-2.4 s-2.4,1.1-2.4,2.4V11.2z"
  }));
};

exports["default"] = _default;